import * as React from 'react';
import _ from 'lodash';
import { AppEnvironments } from 'src/utils/types/env';
import { OutputChannels } from 'src/modules/locale';

const getOneTrustTestCookieScripts = (channel: string) => {
  if (channel === OutputChannels.DE) {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="6a2b3373-0d17-43f7-82bc-ac42a34f0306-test"></script>
    );
  }
  if (channel === OutputChannels.US) {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="dbf88a97-2ef5-4dce-97da-4e3e2418d752-test"></script>
    );
  }
  if (channel === OutputChannels.AU) {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="ab0154f3-9615-4d82-9c3a-22eb16e0a4d0-test"></script>
    );
  }

  return null;
};

const getOneTrustProductionCookieScripts = (channel: string) => {
  if (channel === OutputChannels.DE) {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="6a2b3373-0d17-43f7-82bc-ac42a34f0306"></script>
    );
  }
  if (channel === OutputChannels.US) {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="dbf88a97-2ef5-4dce-97da-4e3e2418d752"></script>
    );
  }
  if (channel === OutputChannels.AU) {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="ab0154f3-9615-4d82-9c3a-22eb16e0a4d0"></script>
    );
  }

  return null;
};

let __lastLog = '';

/**
 * Workaround since appEnv from locale is currently not working
 * TODO: use NEXT_PUBLIC_ variable instead of this
 */
const getEnvironmentWorkaround = () => {
  if (typeof location === 'undefined') return null;

  const productionHosts = [/walter-k.com/i, /walterknoll.de/i, /walterknoll.com.au/i];

  if (_.find(productionHosts, (productionHost) => location.host.match(productionHost))) {
    return AppEnvironments.Production;
  }

  return AppEnvironments.Test;
};

const getOneTrustScript = (channel: string) => {
  const environment = getEnvironmentWorkaround();

  const channelAndEnv = `${channel}-${environment}`;

  // only log once
  if (__lastLog !== channelAndEnv) {
    __lastLog = channelAndEnv;
  }

  if (!environment) return null;

  if (environment === AppEnvironments.Production) {
    return getOneTrustProductionCookieScripts(channel);
  }

  return getOneTrustTestCookieScripts(channel);
};

export default getOneTrustScript;
